import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import Warehouse from "../warehouse/Warehouse";
import User from "../user/User";
import Image from "../image/Image";
import ProductOverview from "./ProductOverview";
import StoreDomainProductMapping from "./StoreDomainProductMapping";
import InventoryCollection from "../inventory/InventoryCollection";
import OfferCollection from "../offer/OfferCollection";
import JsonMappedModel from "../helpers/JsonMappedModel";
import ProductVariationCollection from "./ProductVariationCollection";
import ImageCollection from "../image/ImageCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Product extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Product.id_attribute_name]: null,
      [Product.warehouse_id_attribute_name]: null,
      [Product.name_attribute_name]: null,
      [Product.created_at_attribute_name]: null,
      [Product.deleted_at_attribute_name]: null,
      [Product.description_attribute_name]: null,
      [Product.code_attribute_name]: null,
      [Product.warehouse_attribute_name]: Warehouse,
      [Product.advertiser_attribute_name]: User,
      [Product.status_attribute_name]: Product.DRAFT_STATUS,
      [Product.inventories_attribute_name]: InventoryCollection,
      [Product.image_attribute_name]: Image,
      [Product.overview_attribute_name]: ProductOverview,
      [Product.offers_attribute_name]: OfferCollection,
      [Product.product_gallery_attribute_name]: Image,
      [Product.variant_type_attribute_name]: Product.SINGLE_VARIANT_TYPE,
      [Product.variations_attribute_name]: ProductVariationCollection,
      [Product.wc_product_mapping_attribute_name]: StoreDomainProductMapping,
      [Product.private_note_attribute_name]: null,
      [Product.sale_price_attribute_name]: null,
      [Product.gallery_attribute_name]: ImageCollection
    });
    _defineProperty(this, "tab", {
      fieldName: 'tab',
      loading: false,
      content: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  static getDescriptionAttributeName() {
    return this.description_attribute_name;
  }
  static getPrivateNoteAttributeName() {
    return this.private_note_attribute_name;
  }
  static getSkuAttributeName() {
    return this.code_attribute_name;
  }
  static getAdvertiserAttributeName() {
    return this.advertiser_attribute_name;
  }
  static getImageAttributeName() {
    return this.image_attribute_name;
  }
  static getWarehouseAttributeName() {
    return this.warehouse_attribute_name;
  }
  static getStatusAttributeName() {
    return this.status_attribute_name;
  }
  static getVariationTypeAttributeName() {
    return this.variant_type_attribute_name;
  }
  static getVariationsAttributeName() {
    return this.variations_attribute_name;
  }
  static getGalleryAttributeName() {
    return this.gallery_attribute_name;
  }
  getProductSku() {
    return this.getAttribute(Product.code_attribute_name);
  }
  getSku() {
    return this.getAttribute(Product.code_attribute_name);
  }
  getAdvertiser() {
    return this.getAttribute(Product.advertiser_attribute_name);
  }
  getAdvertiserName() {
    let advertiser = this.getAdvertiser();
    return advertiser instanceof User ? advertiser.getName() : null;
  }
  getInventories() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(Product.inventories_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getWarehouse() {
    return this.getAttribute(Product.warehouse_attribute_name);
  }
  getWarehouseName() {
    let warehouse = this.getWarehouse();
    return warehouse instanceof Warehouse ? warehouse.getName() : null;
  }
  getWarehouseImageUrl() {
    let warehouse = this.getWarehouse();
    return warehouse instanceof Warehouse ? warehouse.getImageUrl() : null;
  }
  getProductSelectObject(text = 'text', value = 'value') {
    return {
      [text !== null && text !== void 0 ? text : 'text']: this.getName(),
      [value !== null && value !== void 0 ? value : 'value']: this.getId()
    };
  }
  getImage() {
    return this.getAttribute(Product.image_attribute_name);
  }
  getName() {
    return this.getAttribute(Product.name_attribute_name);
  }
  getDescription() {
    return this.getAttribute(Product.description_attribute_name);
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getVariationType() {
    return this.getAttribute(Product.variant_type_attribute_name);
  }
  getVariations() {
    return this.getAttribute(Product.variations_attribute_name);
  }
  isVariationMultiple() {
    return this.getVariationType() === Product.MULTIPLE_VARIANT_TYPE;
  }
  hasVariations() {
    return this.isVariationMultiple();
  }
  isVariationSingle() {
    return this.getVariationType() === Product.SINGLE_VARIANT_TYPE;
  }
  getDeleteDate() {
    return this.getAttribute(Product.deleted_at_attribute_name);
  }
  getPrivateNote() {
    return this.getAttribute(Product.private_note_attribute_name);
  }
  getStatus() {
    return this.getAttribute(Product.status_attribute_name);
  }
  getSalePrice() {
    return this.getAttribute(Product.sale_price_attribute_name);
  }
}
_defineProperty(Product, "ACTIVE_STATUS", 'active');
_defineProperty(Product, "DRAFT_STATUS", 'draft');
_defineProperty(Product, "MULTIPLE_VARIANT_TYPE", 'multiple');
_defineProperty(Product, "SINGLE_VARIANT_TYPE", 'single');
_defineProperty(Product, "id_attribute_name", 'product_id');
_defineProperty(Product, "warehouse_id_attribute_name", 'warehouse_id');
_defineProperty(Product, "name_attribute_name", 'product_name');
_defineProperty(Product, "created_at_attribute_name", 'created_at');
_defineProperty(Product, "deleted_at_attribute_name", 'deleted_at');
_defineProperty(Product, "description_attribute_name", 'product_description');
_defineProperty(Product, "code_attribute_name", 'product_code');
_defineProperty(Product, "warehouse_attribute_name", 'product_warehouse');
_defineProperty(Product, "advertiser_attribute_name", 'product_advertiser');
_defineProperty(Product, "status_attribute_name", 'product_status');
_defineProperty(Product, "inventories_attribute_name", 'product_inventories');
_defineProperty(Product, "image_attribute_name", 'image');
_defineProperty(Product, "overview_attribute_name", 'product_overview');
_defineProperty(Product, "offers_attribute_name", 'product_offers');
_defineProperty(Product, "product_gallery_attribute_name", 'product_gallery');
_defineProperty(Product, "variant_type_attribute_name", 'variant_type');
_defineProperty(Product, "variations_attribute_name", 'product_variations');
_defineProperty(Product, "wc_product_mapping_attribute_name", 'wc_product_mapping');
_defineProperty(Product, "private_note_attribute_name", 'private_note');
_defineProperty(Product, "sale_price_attribute_name", 'sale_price');
_defineProperty(Product, "gallery_attribute_name", 'gallery');